import {connect} from "react-redux";
import RejectActivity from "./Reject";
import {bindActionCreators} from "redux";
import {rejectActivity} from "../../../../service/Activity/action";
import {viewActivity} from "../../../../service/Activity/action";
import {markAttendances, userCheckout} from "../../../../service/Dealer/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    rejectActivityDetails:state.Activity.rejectActivity,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    activityByIdDetails:state.Activity.activityByIdDetails,
    markAttendanceDetails:state.Dealer.markAttendance,
    isCheckoutDetails:state.Dealer.isCheckoutDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            rejectActivity,
            viewActivity,
            markAttendances,
            userCheckout
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RejectActivity);
